import React from 'react';
import { Route, Switch } from 'react-router';
import { useLoading } from './use-loading';

const render = (page, loadStatus) => {
    return props =>
        page.render({
            ...props,
            loadStatus,
            pageType: page.pageType
        });
};

export const RouteMapRoutes = ({ routeMap }) => {
    const loading = useLoading(routeMap);
    return (
        <Switch>
            {Object.values(routeMap).map(route => (
                <Route
                    key={route.path}
                    path={route.path}
                    render={render(route, loading)}
                    exact={route.exact}
                    strict={route.strict}
                />
            ))}
        </Switch>
    );
};
